import React, { Component } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class InputDestinatarioReporte extends Component {
    constructor(props) {
        super(props);
        this.changeInput = this.changeInput.bind(this);
    }

    changeInput(event) {
        this.props.changeInput("DESTINATARIO", event.target.value)
    }

    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;

        if (!this.props.data.edicion) {
            errorContainer = <label className="error">
                {(errors = getFieldError('receiver')) ? errors.join(',') : null}</label>
        } else {
            errorContainer = <label className="error">
                {(errors = getFieldError('receiver')) ?
                    this.props.form.isFieldTouched("receiver") ?
                        errors.join(',') : null
                    : null}</label>
        }
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-5">
                            <label className="label-primary">Destinatario</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-5">
                            <GenericInputValidate
                                getFieldProps={getFieldProps('receiver', {
                                    onChange(e) {
                                        me.changeInput(e);
                                    },
                                    rules: [{
                                        required: true,
                                        pattern: /^[áéíóúÁÉÍÓÚüÜñÑ0-9A-Za-z\s]+$/,
                                        message: 'Debe ingresar un destinatario válido.'
                                    }]
                                })}
                                id="receiver"
                                name="receiver"
                                value={this.props.data.ReportReceiver}
                                className="form-control default-input"
                                maxLength="30"
                                autoComplete="off"
                            />
                            {errorContainer}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default InputDestinatarioReporte;